exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.chunk-loading[data-v-c205936e] {\n  margin: -12px;\n  display: flex;\n  width: calc(100% + 24px);\n}\n.chunk-loading .chunk-loading-part[data-v-c205936e] {\n  height: 25px;\n  line-height: 25px;\n  flex: 1;\n  background: #ccc;\n  font-size: 14px;\n  color: white;\n  text-align: center;\n}\n.chunk-loading .chunk-loading-part.chunk-loading-part__uploaded[data-v-c205936e] {\n  background: #28A745;\n}\n", ""]);

// exports
